module.exports = __webpack_public_path__ + "static/media/p5_face1.e21fe243.png";